export const DefaultLabelAnimation = {
    mode: "same-time",
    duration: 300,
    easing: "linear"
};
//# sourceMappingURL=animate.js.map
